import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChartHorizontal = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 5C4.44772 5 4 5.44772 4 6V18C4 18.5523 4.44772 19 5 19C5.55228 19 6 18.5523 6 18V6C6 5.44772 5.55228 5 5 5ZM16 8C16 7.44772 15.5523 7 15 7H8C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H15C15.5523 9 16 8.55228 16 8ZM20 12C20 11.4477 19.5523 11 19 11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H19C19.5523 13 20 12.5523 20 12ZM13 15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H8C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15H13Z"
        />
      </svg>
    );
  }
);
